import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "item-meta-fields"
}
const _hoisted_2 = {
  key: 0,
  class: "item-meta-fields__block"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-m item-meta-fields__block-label" }, "ID", -1)
const _hoisted_4 = {
  key: 1,
  class: "item-meta-fields__block"
}
const _hoisted_5 = { class: "label-m item-meta-fields__block-label" }
const _hoisted_6 = {
  key: 2,
  class: "item-meta-fields__block"
}
const _hoisted_7 = { class: "label-m item-meta-fields__block-label" }
const _hoisted_8 = {
  key: 3,
  class: "item-meta-fields__block n-form-min-h-30"
}
const _hoisted_9 = { class: "label-m item-meta-fields__block-label" }
const _hoisted_10 = { class: "label-m" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonModelCopy = _resolveComponent("ButtonModelCopy")!
  const _component_NDateTimeLabel = _resolveComponent("NDateTimeLabel")!

  return (!_ctx.isNew)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.item.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_ButtonModelCopy, {
                class: "item-meta-fields__block-value",
                "model-value": _ctx.item.id
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.created_date)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.created', 'f')), 1),
              _createVNode(_component_NDateTimeLabel, {
                class: "item-meta-fields__block-value",
                size: "m",
                "model-value": _ctx.item.created_date
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.updated_date)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('common.updated', 'f')), 1),
              _createVNode(_component_NDateTimeLabel, {
                class: "item-meta-fields__block-value",
                size: "m",
                "model-value": _ctx.item.updated_date
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.created_by)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common.created_by', 'f')), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.dataModule.getUserNameById(_ctx.item.created_by)), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}